export const state = () => ({
  businessDetails: {},
  locationDetails: {},
  restaurants: [],
  restaurantDetails: {},
  restaurantChannels: {},
  linkedApps: [],
  headers: {},
  printers: [],
  restaurantInfoLoading: false,
  billingInfo: {},
  subscriptionPlans: {},
  subscription: {},
  isQzConnected: false,
  lastRestaurantInfoFetchedAt: "",
  pointOfContacts: [],
  notifications: [],
  showFeedback: false,
  deliveryConfigurations: {}
});

export const mutations = {
  SET_USER(state, user) {
    state.user = user;
  },
  SET_HEADERS(state, headers) {
    state.headers = headers;
  },
  SET_RESTAURANT_INFO_LOADING(state, restaurantInfoLoading) {
    state.restaurantInfoLoading = restaurantInfoLoading;
  },
  SET_LAST_RESTAURANT_INFO_FETCHED_AT(state, lastRestaurantInfoFetchedAt) {
    state.lastRestaurantInfoFetchedAt = lastRestaurantInfoFetchedAt;
  },
  SET_BUSINESS_DETAILS(state, businessDetails) {
    state.businessDetails = businessDetails;
  },
  SET_LOCATION_DETAILS(state, locationDetails) {
    state.locationDetails = locationDetails;
  },
  SET_RESTAURANT_DETAILS(state, restaurantDetails) {
    state.restaurantDetails = restaurantDetails;
  },
  SET_RESTAURANT_CHANNELS(state, restaurantChannels) {
    state.restaurantChannels = restaurantChannels;
  },
  SET_LINKED_APPS(state, linkedApps) {
    state.linkedApps = linkedApps;
  },
  SET_RESTAURANT_PRINTERS(state, printers) {
    state.printers = printers;
  },
  SET_BILLING_INFO(state, billingInfo) {
    state.billingInfo = billingInfo;
  },
  SET_SUBSCRIPTION_PLANS(state, subscriptionPlans) {
    state.subscriptionPlans = subscriptionPlans;
  },
  SET_SUBSCRIPTION(state, subscription) {
    state.subscription = subscription;
  },
  SET_QZ_CONNECTION_STATUS(state, isQzConnected) {
    state.isQzConnected = isQzConnected;
  },
  SET_POINT_OF_CONTACTS(state, pointOfContacts) {
    state.pointOfContacts = pointOfContacts;
  },
  SET_NOTIFICATIONS(state, notifications) {
    state.notifications = notifications;
  },
  SET_SHOW_FEEDBACK(state, showFeedback) {
    state.showFeedback = showFeedback;
  },
  SET_DELIVERY_CONFIGURATIONS(state, deliveryConfigurations) {
    state.deliveryConfigurations = deliveryConfigurations;
  }
};

export const actions = {
  // OLD
  createRestaurant({ dispatch, commit }, payload) {
    commit("SET_RESTAURANT_INFO_LOADING", true);
    return new Promise((resolve, reject) => {
      this.$axios
        .post("/restaurants", payload)
        .then(function (response) {
          $nuxt.$store.dispatch("auth/profile");
          // commit("SET_USER", response.data.data);
          resolve(response);
        })
        .catch((err) => {
          reject(err);
        })
        .finally(() => {
          commit("SET_RESTAURANT_INFO_LOADING", false);
        });
    });
  },
  createBusiness({ dispatch, commit }, payload) {
    commit("SET_RESTAURANT_INFO_LOADING", true);
    return new Promise((resolve, reject) => {
      this.$axios
        .post("/business", payload, $nuxt.$configData?.apiV2Config)
        .then(function (response) {
          $nuxt.$store.dispatch("auth/profile");
          // commit("SET_USER", response.data.data);
          resolve(response);
        })
        .catch((err) => {
          reject(err);
        })
        .finally(() => {
          commit("SET_RESTAURANT_INFO_LOADING", false);
        });
    });
  },
  updateDevicePreferences({ dispatch, state }, payload) {
    const business = JSON.parse($nuxt.$ls.get("business-id"));
    if (!business) {
      return;
    }

    return new Promise((resolve, reject) => {
      this.$axios
        .put(
          `/business/${business.value}`,
          payload,
          $nuxt.$configData?.apiV2Config
        )
        .then(function (response) {
          resolve(response);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  createBrand({ dispatch, commit }, { restaurant, id }) {
    return new Promise((resolve, reject) => {
      this.$axios
        .post(
          `/restaurants`,
          { location_id: id, restaurant },
          $nuxt.$configData?.apiV2Config
        )
        .then(function (response) {
          dispatch("getLocationDetails");
          resolve(response);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  integrateChannels({ dispatch, commit }, { payload }) {
    commit("SET_RESTAURANT_INFO_LOADING", true);
    return new Promise((resolve, reject) => {
      this.$axios
        .post(
          `restaurant_platforms/integrate`,
          payload,
          $nuxt.$configData?.apiV2Config
        )
        .then(function (response) {
          // commit("SET_USER", response.data.data);
          dispatch("getLocationDetails");
          resolve(response);
        })
        .catch((err) => {
          reject(err);
        })
        .finally(() => {
          commit("SET_RESTAURANT_INFO_LOADING", false);
        });
    });
  },
  disintegrateChannels({ dispatch, commit }, { payload }) {
    commit("SET_RESTAURANT_INFO_LOADING", true);
    return new Promise((resolve, reject) => {
      this.$axios
        .post(
          `restaurant_platforms/disintegrate`,
          payload,
          $nuxt.$configData?.apiV2Config
        )
        .then(function (response) {
          // commit("SET_USER", response.data.data);
          dispatch("getLocationDetails");
          resolve(response);
        })
        .catch((err) => {
          reject(err);
        })
        .finally(() => {
          commit("SET_RESTAURANT_INFO_LOADING", false);
        });
    });
  },
  getLocationDetails({ dispatch, commit }, fetchAll = true) {
    commit("SET_RESTAURANT_INFO_LOADING", true);
    const id = $nuxt.$ls.get("selected-location-id");
    return new Promise((resolve, reject) => {
      this.$axios
        .get(`locations/${id}`, $nuxt.$configData?.apiV2Config)
        .then(function (response) {
          commit("SET_LOCATION_DETAILS", response.data);
          commit("SET_LAST_RESTAURANT_INFO_FETCHED_AT", new Date().getDate());
          dispatch("getNotifications", response.data?.id);
          if (fetchAll) {
            dispatch("getLocationLinkedApps", response.data?.id);
            dispatch("getLocationPrinters", {
              id: response.data?.id,
              forceFetch: true
            });
            $nuxt.$store.commit(
              "report/SET_REPORT_RESTAURANT",
              response.data.restaurants?.map((el) => el.id)
            );
            // if (
            //   response.data?.features?.socket &&
            //   response.data?.features?.socket != "false"
            // )
            // $nuxt.$store.dispatch(
            //   "reciever/getSocketDetails",
            //   response.data.id
            // );
          }
          resolve(response);
        })
        .catch((err) => {
          reject(err);
        })
        .finally(() => {
          commit("SET_RESTAURANT_INFO_LOADING", false);
        });
    });
  },
  // OLD
  getRestaurantDetails({ dispatch, commit }, fetchAll = true) {
    const id = $nuxt.$ls.get("selected-restaurant-id");
    commit("SET_RESTAURANT_INFO_LOADING", true);
    return new Promise((resolve, reject) => {
      this.$axios
        .post(`/restaurants/${id}/info`, { platform: "web" })
        .then(function (response) {
          if (fetchAll) {
            // dispatch("getLocationLinkedApps", response.data.data.id);
            // dispatch("getRestaurantPrinters", response.data.data.id);
            // if (
            //   response.data.data.features.socket &&
            //   response.data.data.features.socket != "false"
            // )
            //   $nuxt.$store.dispatch(
            //     "reciever/getSocketDetails",
            //     response.data.data.id
            //   );
          }
          if (response.data.data.working_days) {
            response.data.data.working_days.sort((a, b) => {
              return a.id - b.id;
            });
          }
          commit("SET_RESTAURANT_DETAILS", response.data.data);
          commit("SET_LAST_RESTAURANT_INFO_FETCHED_AT", new Date().getDate());
          if (
            !response.data.data.setting?.receiver
              ?.enable_auto_store_availability
          ) {
            $nuxt.$emit("check-auto-store-availability");
          }
          $nuxt.$ls.set(
            "details",
            JSON.stringify({ value: response.data.data, expire: null })
          );
          $nuxt.$ls.set(
            "id",
            JSON.stringify({ value: response.data.data.id, expire: null })
          );
          resolve(response);
        })
        .catch((err) => {
          reject(err);
        })
        .finally(() => {
          commit("SET_RESTAURANT_INFO_LOADING", false);
        });
    });
  },
  getLocationLinkedApps({ dispatch, commit }, id) {
    if (!id) {
      id = $nuxt.$ls.get("selected-location-id");
    }
    commit("SET_RESTAURANT_INFO_LOADING", true);
    return new Promise((resolve, reject) => {
      this.$axios
        .get(`/linked_apps`, {
          params: { location_id: id },
          ...$nuxt.$configData?.apiV2Config
        })
        .then(function (response) {
          $nuxt.$ls.set(
            "apps",
            JSON.stringify({ value: response.data.data, expire: null })
          );
          commit("SET_LINKED_APPS", response.data);
          resolve(response);
        })
        .catch((err) => {
          reject(err);
        })
        .finally(() => {
          commit("SET_RESTAURANT_INFO_LOADING", false);
        });
    });
  },
  getRestaurantChannels({ dispatch, commit }, id) {
    if (!id) {
      id = $nuxt.$ls.get("selected-restaurant-id");
    }
    commit("SET_RESTAURANT_INFO_LOADING", true);
    return new Promise((resolve, reject) => {
      this.$axios
        .get(`/restaurants/${id}/show-channels`, {
          params: { platform: "web" }
        })
        .then(function (response) {
          commit("SET_RESTAURANT_CHANNELS", response.data.data);
          resolve(response);
        })
        .catch((err) => {
          reject(err);
        })
        .finally(() => {
          commit("SET_RESTAURANT_INFO_LOADING", false);
        });
    });
  },
  getSubscriptionPlans({ dispatch, commit }) {
    return new Promise((resolve, reject) => {
      this.$axios
        // .get(`/restaurants/${id}/subscription`)
        .get(`/app_subscriptions/plans`)
        .then(function (response) {
          commit("SET_SUBSCRIPTION_PLANS", response.data);
          resolve(response);
        })
        .catch((err) => {
          reject(err);
        })
        .finally(() => {});
    });
  },
  getSubscription({ dispatch, commit }, id) {
    if (!id) {
      id = $nuxt.$ls.get("selected-location-id");
    }
    return new Promise((resolve, reject) => {
      this.$axios
        // .get(`/restaurants/${id}/subscription`)
        .get(`/app_subscriptions/status`, { params: { location_id: id } })
        .then(function (response) {
          commit("SET_SUBSCRIPTION", response.data);
          resolve(response);
        })
        .catch((err) => {
          reject(err);
        })
        .finally(() => {});
    });
  },
  createSubscription({ dispatch, commit }, payload) {
    return new Promise((resolve, reject) => {
      this.$axios
        .post(`app_subscriptions/subscriptions`, payload)
        .then(function (response) {
          commit("SET_SUBSCRIPTION", response.data.data);
          resolve(response);
        })
        .catch((err) => {
          reject(err);
        })
        .finally(() => {});
    });
  },
  cancelSubscription({ dispatch, commit }, payload, id) {
    if (!id) {
      id = $nuxt.$ls.get("selected-restaurant-id");
    }
    return new Promise((resolve, reject) => {
      this.$axios
        .post(`/restaurants/${id}/cancel-subscription`)
        .then(function (response) {
          commit("SET_SUBSCRIPTION", {});
          resolve(response);
        })
        .catch((err) => {
          reject(err);
        })
        .finally(() => {});
    });
  },
  getBillingInfo({ dispatch, commit }, id) {
    if (!id) {
      id = $nuxt.$ls.get("selected-restaurant-id");
    }
    return new Promise((resolve, reject) => {
      this.$axios
        .get(`/restaurants/${id}/billing-info`)
        .then(function (response) {
          commit("SET_BILLING_INFO", response.data.data);
          resolve(response);
        })
        .catch((err) => {
          reject(err);
        })
        .finally(() => {});
    });
  },
  postRestaurantFeedback({ dispatch, commit }, payload) {
    const id = $nuxt.$ls.get("selected-restaurant-id");
    commit("SET_RESTAURANT_INFO_LOADING", true);
    return new Promise((resolve, reject) => {
      this.$axios
        .post(`/restaurants/${id}/feedbacks`, payload)
        .then(function (response) {
          resolve(response);
        })
        .catch((err) => {
          reject(err);
        })
        .finally(() => {
          commit("SET_RESTAURANT_INFO_LOADING", false);
        });
    });
  },
  updateRestaurantDetails({ dispatch, state }, payload) {
    const id = $nuxt.$ls.get("selected-restaurant-id");
    return new Promise((resolve, reject) => {
      this.$axios
        .put(`restaurants/${id}`, payload)
        .then(async function (response) {
          await dispatch("getLocationDetails");
          resolve(response);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  getLocationPrinters({ dispatch, commit, state }, { id, forceFetch = false }) {
    if (!forceFetch && state.printers && state.printers.length) return;
    if (!id) {
      id = $nuxt.$ls.get("selected-location-id");
    }
    return new Promise((resolve, reject) => {
      this.$axios
        .get(`/printers`, {
          params: { location_id: id },
          ...$nuxt.$configData?.apiV2Config
        })
        .then(function (response) {
          commit("SET_RESTAURANT_PRINTERS", response.data);
          resolve(response);
        })
        .catch((err) => {
          reject(err);
        })
        .finally(() => {});
    });
  },
  addNewKotPrinter({ commit, state, dispatch }, { printer }) {
    const id = $nuxt.$ls.get("selected-location-id");
    return new Promise((resolve, reject) => {
      this.$axios
        .post(
          `/printers`,
          { location_id: id, printer },
          $nuxt.$configData?.apiV2Config
        )
        .then(function (response) {
          if (!state.printers.length) {
            dispatch("getLocationDetails", false);
          }
          resolve(response);
        })
        .catch((err) => {
          reject(err);
        })
        .finally(() => {});
    });
  },
  updatePrinter({ dispatch, state }, { printer, payload }) {
    return new Promise((resolve, reject) => {
      this.$axios
        .put(`printers/${printer}`, payload, $nuxt.$configData?.apiV2Config)
        .then(async function (response) {
          resolve(response);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  deletePrinter({ dispatch, state }, { printer }) {
    return new Promise((resolve, reject) => {
      this.$axios
        .delete(`printers/${printer}`, {
          ...$nuxt.$configData?.apiV2Config
        })
        .then(async function (response) {
          resolve(response);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  assignItemsToPrinter({ dispatch, state }, { printer, payload }) {
    const id = $nuxt.$ls.get("selected-restaurant-id");
    return new Promise((resolve, reject) => {
      this.$axios
        .put(
          `/printers/${printer}/items`,
          payload,
          $nuxt.$configData?.apiV2Config
        )
        .then(async function (response) {
          resolve(response);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },

  updateRestaurantSettings({ dispatch, state }, { settings, id }) {
    return new Promise((resolve, reject) => {
      this.$axios
        .put(
          `/restaurants/${id}/settings`,
          {
            app: "receiver",
            settings: settings
          },
          $nuxt.$configData?.apiV2Config
        )
        .then(async function (response) {
          await dispatch("getLocationDetails");
          resolve(response);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  updateRestaurantAvailabilityTiming({ dispatch }, { availability }) {
    const id = $nuxt.$ls.get("selected-restaurant-id");
    return new Promise((resolve, reject) => {
      this.$axios
        .post(
          `/restaurants/${id}/store_availability`,
          {
            availability
          },
          $nuxt.$configData?.apiV2Config
        )
        .then(async function (response) {
          await dispatch("getLocationDetails");
          resolve(response);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  updateIntegrationStatus({ dispatch }, { brandId, payload }) {
    return new Promise((resolve, reject) => {
      this.$axios
        .put(
          `/restaurants/${brandId}/integration_status`,
          payload,
          $nuxt.$configData?.apiV2Config
        )
        .then(async function (response) {
          await dispatch("getLocationDetails");
          resolve(response);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  getPointOfContact({ state, commit }) {
    const id = $nuxt.$ls.get("selected-location-id");
    const brandId = state.locationDetails?.restaurants[0]?.id;

    return new Promise((resolve, reject) => {
      this.$axios
        .get(
          `/restaurants/${brandId}/point_of_contacts`,
          $nuxt.$configData?.apiV2Config
        )
        .then(async function (response) {
          commit("SET_POINT_OF_CONTACTS", response.data || []);
          resolve(response);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  createPointOfContact({ state, dispatch }, { payload }) {
    const id = $nuxt.$ls.get("selected-location-id");
    const brandId = state.locationDetails?.restaurants[0]?.id;

    return new Promise((resolve, reject) => {
      this.$axios
        .post(
          `/restaurants/${brandId}/point_of_contacts`,
          payload,
          $nuxt.$configData?.apiV2Config
        )
        .then(async function (response) {
          await dispatch("getPointOfContact");
          resolve(response);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  updatePointOfContact({ state, dispatch }, { payload }) {
    const id = $nuxt.$ls.get("selected-location-id");
    const brandId = state.locationDetails?.restaurants[0]?.id;

    return new Promise((resolve, reject) => {
      this.$axios
        .put(
          `/restaurants/${brandId}/point_of_contacts`,
          payload,
          $nuxt.$configData?.apiV2Config
        )
        .then(async function (response) {
          await dispatch("getPointOfContact");
          resolve(response);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  submitSurvey({ dispatch }, payload) {
    return new Promise((resolve, reject) => {
      this.$axios
        .post(`/surveys`, payload, $nuxt.$configData?.apiV2Config)
        .then(async function (response) {
          await dispatch("getSurveyStatus");
          resolve(response);
        })
        .catch((err) => {
          reject(err);
        })
        .finally(() => {});
    });
  },
  getSurveyStatus({ commit }) {
    const id = $nuxt.$ls.get("selected-location-id");
    return new Promise((resolve, reject) => {
      this.$axios
        .get(`/surveys?location_id=${id}`, {
          ...$nuxt.$configData?.apiV2Config
        })
        .then(function (response) {
          if (response.data?.surveys) {
            commit("SET_SHOW_FEEDBACK", !response.data.surveys.length);
          }
          resolve(response);
        })
        .catch((err) => {
          reject(err);
        })
        .finally(() => {});
    });
  },
  getNotifications({ commit }, id) {
    id = id || $nuxt.$ls.get("selected-location-id");
    return new Promise((resolve, reject) => {
      this.$axios
        .get(`/notifications?location_id=${id}`, {
          ...$nuxt.$configData?.apiV2Config
        })
        .then(function (response) {
          if (response.data) {
            commit("SET_NOTIFICATIONS", response.data);
          }
          resolve(response);
        })
        .catch((err) => {
          reject(err);
        })
        .finally(() => {});
    });
  },
  updateNotifications({ commit }, { id, payload }) {
    return new Promise((resolve, reject) => {
      this.$axios
        .put(
          `/notifications/${id}/mark_as_read`,
          payload,
          $nuxt.$configData?.apiV2Config
        )
        .then(function (response) {
          resolve(response);
        })
        .catch((err) => {
          reject(err);
        })
        .finally(() => {});
    });
  },
  createDeliveryConfiguration({ dispatch }, { channelId, payload }) {
    return new Promise((resolve, reject) => {
      this.$axios
        .post(
          `/restaurant_platforms/${channelId}/delivery_configuration`,
          payload,
          $nuxt.$configData?.apiV2Config
        )
        .then(function (response) {
          resolve(response);
        })
        .catch((err) => {
          reject(err);
        })
        .finally(() => {});
    });
  },
  updateDeliveryConfiguration({ dispatch }, { channelId, payload }) {
    return new Promise((resolve, reject) => {
      this.$axios
        .put(
          `/restaurant_platforms/${channelId}/delivery_configuration`,
          payload,
          $nuxt.$configData?.apiV2Config
        )
        .then(function (response) {
          resolve(response);
        })
        .catch((err) => {
          reject(err);
        })
        .finally(() => {});
    });
  },
  getDeliveryConfiguration({ dispatch, commit }, channelId) {
    return new Promise((resolve, reject) => {
      this.$axios
        .get(`/restaurant_platforms/${channelId}/delivery_configuration`, {
          ...$nuxt.$configData?.apiV2Config
        })
        .then(function (response) {
          commit("SET_DELIVERY_CONFIGURATIONS", response.data);
          resolve(response);
        })
        .catch((err) => {
          reject(err);
        })
        .finally(() => {});
    });
  },
  getServiceability({ dispatch, commit }) {
    const id = $nuxt.$ls.get("selected-location-id");
    return new Promise((resolve, reject) => {
      this.$axios
        .get(`/locations/${id}/logistics_serviceability`, {
          ...$nuxt.$configData?.apiV2Config
        })
        .then(function (response) {
          resolve(response);
        })
        .catch((err) => {
          reject(err);
        })
        .finally(() => {});
    });
  }
};

export const getters = {
  restaurantInfoLoading(state) {
    return state.restaurantInfoLoading;
  },
  getLocationChannels({ locationDetails }) {
    let channels = [];
    $nuxt.$constants.Channels.CHANNELS.forEach((channel) => {
      const restaurants = locationDetails.restaurants.filter((restaurant) => {
        return restaurant.restaurant_platforms.some(
          (platform) => platform.platform_name === channel.name
        );
      });
      if (restaurants?.length) {
        channels.push({
          name: channel.name,
          restaurants
        });
      }
    });
    return channels;
  },
  getUnpairedChannelsList({}, { getLocationChannels }) {
    if (getLocationChannels?.length) {
      return $nuxt.$constants.Channels.CHANNELS.filter((channel) => {
        return !getLocationChannels.some((linkedChannel) => {
          return channel.name == linkedChannel.name;
        });
      });
    } else {
      return $nuxt.$constants.Channels.CHANNELS;
    }
  },
  getChannelNames({}, { getLocationChannels }) {
    const channels = getLocationChannels.map((channel) => channel.name);
    if (channels.length > 1) {
      return channels.slice(0, -1).join(", ") + " and " + channels.slice(-1);
    } else {
      return channels[0] || "";
    }
  },
  isRecieverSubscribed({ linkedApps }) {
    return (
      linkedApps &&
      linkedApps.some((app) => {
        return app.source == "receiver_app";
      })
    );
  },
  getAllBrands({ locationDetails }) {
    return locationDetails.restaurants?.length
      ? locationDetails.restaurants
      : [];
  },
  getRestaurantDetailedInfo({ locationDetails }) {
    return function (id) {
      return (
        locationDetails.restaurants.find((restaurant) => {
          return restaurant.id == id;
        }) || {}
      );
    };
  },
  getRecieverSettings({}, { getRestaurantDetailedInfo }) {
    return (id) => getRestaurantDetailedInfo(id)?.settings || {};
  },
  getRestaurantFeatures({}, { getRestaurantDetailedInfo }) {
    return (id) => getRestaurantDetailedInfo(id)?.features || {};
  },
  getRestaurantName({}, { getRestaurantDetailedInfo }) {
    return (id) => getRestaurantDetailedInfo(id)?.name || "";
  },
  hasMultipleBrands({ businessDetails }) {
    return (
      businessDetails.business_type ===
      $nuxt.$constants.BusinessTypes.MULTIPLE_BRAND_SINGLE_OUTLET.id
    );
  },
  isLocationOnline({ locationDetails }) {
    return locationDetails?.restaurants?.some((restaurant) =>
      restaurant.restaurant_platforms.some(
        (channel) => channel.state === "online"
      )
    );
  },
  isBrandOnline({ locationDetails }) {
    return function (id) {
      return locationDetails.restaurants
        .find((restaurant) => restaurant.id === id)
        .restaurant_platforms.some((channel) => channel.state === "online");
    };
  },
  offlineChannelCount({ locationDetails }) {
    let count = 0;
    locationDetails.restaurants.forEach((restaurant) => {
      count +=
        restaurant.restaurant_platforms.filter(
          (channel) => channel.state === "offline"
        )?.length || 0;
    });
    return count;
  },
  onlineChannelCount({ locationDetails }) {
    let count = 0;
    locationDetails.restaurants.forEach((restaurant) => {
      count +=
        restaurant.restaurant_platforms.filter(
          (channel) => channel.state === "online"
        )?.length || 0;
    });
    return count;
  },
  activeChannelCount({}, { offlineChannelCount, onlineChannelCount }) {
    return offlineChannelCount + onlineChannelCount;
  },
  totalChannelCount({ locationDetails }) {
    let count = 0;
    locationDetails.restaurants.forEach((restaurant) => {
      count += restaurant.restaurant_platforms?.length || 0;
    });
    return count;
  },
  getMenuUpdateDisabledObj({ notifications }) {
    return notifications.find(
      (el) =>
        el.event === $nuxt.$constants.NotificationEvents.MENU_UPDATE_DISABLED
    );
  },
  getChannelId({ locationDetails }) {
    let channelInfo;
    return function (name) {
      locationDetails.restaurants.forEach((restaurant) => {
        channelInfo = restaurant.restaurant_platforms.find(
          (channel) => channel.platform_name === name
        );
      });
      return channelInfo.id;
    };
  }
};
